import { TThunkAction } from '../../../types/redux';
import { getRealtorRatingListLoading } from './getRealtorRatingListLoading';
import { getRealtorRatingListFailed } from './getRealtorRatingListFailed';
import { getRealtorRatingListSucceed } from './getRealtorRatingListSucceed';
import { fetchGetRatingList, TGetRatingListResponse } from '../../../services/getRealtorRatingList';
import { throwError } from '../../../utils';

interface IGetRealtorRatingListParams {
  region?: number;
  period?: string | number;
  agentId?: number;
}

export const getRealtorRatingList = ({
  region,
  period,
  agentId,
}: IGetRealtorRatingListParams): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(getRealtorRatingListLoading());

    try {
      const { response, statusCode }: TGetRatingListResponse = await fetchGetRatingList({
        httpApi,
        parameters: {
          region_id: region ? region : undefined,
          year: Number(period) ? period : undefined,
          agent_id: agentId ? agentId : undefined,
        },
      });

      if (statusCode !== 200) {
        throwError({
          message: 'Не удалось загрузить рейтинг риелторов',
          statusCode,
          domain: 'actions.getRealtorRatingList',
        });

        return;
      }

      dispatch(getRealtorRatingListSucceed({ items: response.data }));
    } catch (e) {
      logger.error(e, {
        domain: 'actions.getRealtorRatingList',
      });

      dispatch(getRealtorRatingListFailed());
    }
  };
};
